<svg width="48"
     height="49"
     viewBox="0 0 48 49"
     fill="none"
     xmlns="http://www.w3.org/2000/svg"
     aria-hidden="true"
     focusable="false">
      <line x1="14.15"
            y1="25.35"
            x2="33.85"
            y2="25.35"
            stroke="currentColor"
            stroke-width="2.3"
            stroke-linecap="round" />
      <line x1="14.15"
            y1="19.35"
            x2="33.85"
            y2="19.35"
            stroke="currentColor"
            stroke-width="2.3"
            stroke-linecap="round" />
      <line x1="14.15"
            y1="31.35"
            x2="33.85"
            y2="31.35"
            stroke="currentColor"
            stroke-width="2.3"
            stroke-linecap="round" />
</svg>